export default __webpack_public_path__ + "static/media/IMG_1447.5b37d5f6.jpg";